import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Wizard from "../components/UI/Wizard";
import arrowLeft from "../../assets/icons/arrowLeft.svg";
import icons from "bootstrap-italia/dist/svg/sprites.svg";

function Servizio() {
  const navigate = useNavigate();

  return (
    <main className="my-4">
      <div className="container">
        <div className="col-12 col-lg-10">
          <div className="row justify-content-center">
            <div className="cmp-hero">
              <section className="bg-white align-items-start">
                <div className="it-hero-text-wrapper pt-0 ps-0 pb-3 pb-lg-4">
                  <div
                    class="mb-3 flex"
                    style={{
                      marginTop: "2.22rem",
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "#146995",
                    }}
                  >
                    <a href="/" class="flex items-center mr-1">
                      Home
                    </a>
                    <span> / </span>
                    <a
                      class="flex items-center ml-1"
                      href="/prenotazione-appuntamento"
                    >
                      {" "}
                      Prenotazione appuntamento
                    </a>
                  </div>
                  <h1
                    className="text-black hero-title"
                    data-element="page-name"
                  >
                    Prenotazione appuntamento
                  </h1>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <Wizard />
      </div>
    </main>
  );
}

export default Servizio;
